module.exports = __webpack_public_path__ + "images/19132-EXT1-Cam07_Dusk-653afa63fe5e2f796ba99f767cdb9dd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_2/19132-EXT1-Cam07_Dusk.jpg
// module id = 750
// module chunks = 0